import api from "@/lib/api";

export const fileUrl = (u) =>
  !u ? "" : (String(u).startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export async function uploadFiles(rid, files) {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  const { data } = await api.post(`/restaurants/${rid}/upload`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.files.map((f) => f.url);
}
